import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SimpleSpinner from '@/components/SimpleSpinner.vue'
import PageContainer from '@/mobile/src/components/appV4/PageContainer.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingWithGradientBg',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContainer, null, {
    default: _withCtx(() => [
      _createVNode(SimpleSpinner, {
        size: "small",
        class: "spinner",
        "line-fg-color": "transparent"
      })
    ], undefined, true),
    _: 1
  }))
}
}

})